import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStatus } from '../hooks/useAuthStatus';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const { loggedIn } = useAuthStatus();

  const pathMatchRoute = route => {
    if (route === location.pathname) {
      return true;
    }
  };

  return (
    <div className="navbar">
      <button
        className={pathMatchRoute('/') ? 'btn__active' : 'btn'}
        onClick={() => {
          navigate('/');
        }}
      >
        Home
      </button>

      <button
        className={pathMatchRoute('/books') ? 'btn__active' : 'btn'}
        onClick={() => {
          navigate('/books');
        }}
      >
        Books
      </button>

      <button
        className={pathMatchRoute('/e-books') ? 'btn__active' : 'btn'}
        onClick={() => {
          navigate('/e-books');
        }}
      >
        E-Books
      </button>

      <button
        className={pathMatchRoute('/login') ? 'btn__active' : 'btn'}
        onClick={() => {
          loggedIn ? navigate('/my-library') : navigate('/login');
        }}
      >
        My Library
      </button>
    </div>
  );
}

export default Navbar;
